import React, { useCallback, useEffect, useState } from "react";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { viewRewardCouponList, changeRewardCouponStatus } from "../../Redux/Actions/rewardCouponActions";
import { columnsRewardCoupon } from "../../Global Functions/columnsAntd";
import "./listRewardCoupon.css";
import toast from "react-hot-toast";
import DateRangePopup from "../../Utils/dateFilterPopup";
import ListTopSearch from "../../Global Functions/listTopSearch";
// import MainLayout from "../../Layout/mainLayout";

const ListRewardCoupon = () => {
    const dispatch = useDispatch();
    const [searchQuery, setSearchQuery] = useState("");
    const [dateRange, setDateRange] = useState({ start: null, end: null });
    const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
    const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);

    const { admin } = useSelector((state) => state.admin || {});
    const accessCode = admin?.data?.access_code || [];
    const canAdd = Array.isArray(accessCode) && accessCode.includes("add");

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["5", "10", "20", "50", "100"],
    });

    const fetchDetails = useCallback(
        async (page, pageSize, showLoader = true) => {
            const payload = {
                page,
                limit: pageSize,
                filter: debouncedSearch,
                ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
                ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
            };
            try {
                await dispatch(viewRewardCouponList(payload, showLoader));
                if (!showLoader) toast.success("List refreshed");
            } catch {
                if (!showLoader) toast.error("Failed to refresh list");
            }
        },
        [dispatch, debouncedSearch, dateRange]
    );

    useEffect(() => {
        fetchDetails(pagination.current, pagination.pageSize);
    }, [fetchDetails, pagination.current, pagination.pageSize]);

    const { rewardCoupons, loading } = useSelector((state) => state.rewardCoupon || {});

    useEffect(() => {
        if (rewardCoupons?.total) {
            setPagination((prev) => ({ ...prev, total: rewardCoupons.total }));
        }
    }, [rewardCoupons]);

    useEffect(() => {
        const handler = setTimeout(() => setDebouncedSearch(searchQuery), 500);
        return () => clearTimeout(handler);
    }, [searchQuery]);

    const handleTableChange = (pagination) => setPagination(pagination);

    const handleDateRangeApply = (start, end) => {
        setDateRange(start === null && end === null ? { start: null, end: null } : { start, end });
        setIsDatePopupVisible(false);
        setPagination((prev) => ({ ...prev, current: 1 }));
    };

    const handleStatusChange = async (record, newStatus) => {
        const res = await dispatch(changeRewardCouponStatus({ id: record._id, status: newStatus }));
        if (res?.statusCode === 200) {
            fetchDetails(pagination.current, pagination.pageSize);
        }
    };

    return (
        <>
            <div className="lrc-container">
                <div className="lrc-table-wrap">
                    <ListTopSearch
                        buttonhead={canAdd ? "Add Reward Coupon" : null}
                        navigateTo={canAdd ? "/reward_coupon/add" : null}
                        h3heading="Reward Coupon List"
                        setState={setSearchQuery}
                        onCalendarClick={() => setIsDatePopupVisible(true)}
                    />
                    <div style={{ overflowX: "auto", padding: "0px 60px" }}>
                        <Table
                            dataSource={Array.isArray(rewardCoupons?.data) ? rewardCoupons.data : []}
                            pagination={pagination}
                            scroll={{ x: 1400, y: 500 }}
                            onChange={handleTableChange}
                            loading={loading}
                            columns={columnsRewardCoupon(handleStatusChange)}
                            rowKey="_id"
                            rowClassName={() => "text-center"}
                        />
                    </div>
                </div>
                <DateRangePopup
                    visible={isDatePopupVisible}
                    initialStart={dateRange.start}
                    initialEnd={dateRange.end}
                    onCancel={() => setIsDatePopupVisible(false)}
                    onOk={handleDateRangeApply}
                />
            </div>
        </>
    );
};

export default ListRewardCoupon;